/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

/**
 * Currency utility functions to handle different formats (EU vs US)
 */
window.CurrencyUtils = {
  /**
   * Parse price from text, handling both EU (€849,00) and US ($849.00) formats
   * @param {string} priceText - Price text with currency symbol
   * @returns {number} - Parsed price as number
   */
  parsePrice(priceText) {
    if (!priceText) return 0;

    // Remove currency symbols (€, $, ...) and 3-letter ISO codes (AUD, EUR, USD, ...).
    // The trailing replace catches formats without a space, e.g. "$849.00AUD".
    let cleanText = priceText
      .replace(/[€$£¥₹￥]/g, '')
      .replace(/\b[A-Z]{3}\b/g, '')
      .replace(/[A-Z]{3}\s*$/, '')
      .trim();

    // Check if using comma as decimal separator (EU format)
    // EU format: 1.234,56 or 849,00
    // US format: 1,234.56 or 849.00
    const hasCommaDecimal = /\d,\d{2}(?!\d)/.test(cleanText);

    if (hasCommaDecimal) {
      // EU format: remove thousand separators (.), replace decimal comma with dot
      cleanText = cleanText.replace(/\./g, '').replace(',', '.');
    } else {
      // US format: remove thousand separators (,)
      cleanText = cleanText.replace(/,/g, '');
    }

    return parseFloat(cleanText) || 0;
  },

  /**
   * Format price maintaining the original format style
   * @param {number} amount - Price amount
   * @param {string} originalText - Original price text to detect format
   * @returns {string} - Formatted price with currency
   */
  formatPrice(amount, originalText, withCurrency = true) {
    if (!originalText) return amount.toFixed(2);

    // Detect if EU format (comma as decimal separator)
    const hasCommaDecimal = /\d,\d{2}(?!\d)/.test(originalText);

    // Extract currency symbol and trailing ISO code, e.g. the "AUD" in "$849.00 AUD"
    const currencyMatch = originalText.match(/^([€$£¥₹￥])/);
    const currencyPrefix = currencyMatch ? currencyMatch[1] : '';

    const suffixMatch = originalText.match(/([A-Z]{3})\s*$/);
    const currencySuffix = suffixMatch ? ' ' + suffixMatch[1] : '';

    // The extra formatting below (thousands grouping, decimal precision taken from
    // the source text) is opt-in per storefront via window.theme.showCurrencyCode.
    // With the flag off the output stays identical to what this function produced
    // before, so storefronts that don't show currency codes are unaffected.
    const extended = !!(window.theme && window.theme.showCurrencyCode);

    // With the flag on, follow the source text's own decimal precision, so a
    // no-decimals storefront stays "$849 AUD" instead of "$849.00 AUD".
    // With the flag off, keep the historical fixed 2 decimals.
    const decimalMatch = originalText.match(/[.,](\d{1,2})(?!\d)/);
    const precision = !extended ? 2 : decimalMatch ? decimalMatch[1].length : 0;

    let formatted = amount.toFixed(precision);
    if (extended) {
      // Group thousands the same way as the source text: "$2,999.00 AUD" / "2.999,00 €"
      const parts = formatted.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, hasCommaDecimal ? '.' : ',');
      formatted = parts.join(hasCommaDecimal ? ',' : '.');
    } else if (hasCommaDecimal) {
      // EU format: use comma as decimal separator
      formatted = formatted.replace('.', ',');
    }

    return `${currencyPrefix}${formatted}${withCurrency ? currencySuffix : ''}`;
  }
};

if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(".js-product");
      this.productForm = this.section.querySelector(".js-product-form");
      this.formScope = this.productForm?.closest("product-form") || this.section;
      this.optionSelectors = this.querySelectorAll(".option-selector");
      this.data = this.getProductData();

      this.variantMetafield = this.getProductVariantData();
      this.mapVariantIdToOptions(this.data.product.variants);
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;
      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );
      this.dispatchEvent(
        new CustomEvent("on:variant:init", {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product,
          },
        })
      );
      try {
        this.updateProductVariantAdditionData(this.variant, true);
      } catch (err) {
        console.error("$$ updateProductVariantAdditionData get error", err);
      }

      this.updateAvailability();
      this.addEventListener("change", this.handleVariantChange.bind(this));

      try {
        this.initGlobalOptions();
      } catch (err) {
        //console.error('$$ initGlobalOptions get error', err)
      }

      try {
        this.initFixedFooter();
      } catch (err) {
        //console.error('$$ initGlobalOptions get error', err)
      }

      
      try {
        this.initMainBuyBtns();
      } catch (err) {
        console.log('$$ initMainBuyBtns get error', err)
      }
    }

    /**
     * 批量添加到购物车
     * @param items array [{id: variantId, quantity: number}]
     */
    async bulkAddToCart(items) {
      try {
        let sections = 'cart-icon-bubble';
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            items: items,
            sections: sections,
            sections_url: window.location.pathname,
          })
        });

        const data = await response.json();

        if (data.status && data.status !== 'success') {
          throw new Error(data.description || 'Add to cart failed');
        }

        // 更新购物车图标
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble && data.sections && data.sections['cart-icon-bubble']) {
          cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
        }

        // 打开购物车抽屉
        if (cartDrawer) {
          setTimeout(() => cartDrawer.renderContents(data, true), 700);
        }

        // 触发 GTM 埋点（如果有）
        if (typeof logAddToCart === 'function') {
          const gtmItems = items.map((item, index) => {
            const cartItem = data.items?.find(ci => ci.variant_id == item.id);
            return {
              index: index,
              item_id: item.id,
              item_name: cartItem?.title || '',
              item_brand: 'Snapmaker',
              price: cartItem ? cartItem.price / 100 : 0,
              quantity: item.quantity
            };
          });

          const totalPrice = gtmItems.reduce((sum, item) =>
            sum + (item.price * item.quantity), 0
          );

          logAddToCart(gtmItems, 'Add', totalPrice, 'product-page-with-recommended');
        }

        return data;
      } catch (error) {
        console.error('Bulk add to cart failed:', error);
        alert(error.message || 'Failed to add to cart');
        throw error;
      }
    }

    /**
     * 绑定 Buy Now 按钮点击事件
     * @param {HTMLElement} btn 购买按钮元素
     */
    bindBuyNow(btn) {
      btn.addEventListener("click", async (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (btn.getAttribute("aria-disabled") === "true") return;

        btn.setAttribute("aria-disabled", "true");
        btn.classList.add("is-loading");
        try {
          const recommendedProducts = window.RecommendedProducts?.getSelectedProductsForCart() || [];
          const careItems = window.CareUpsell?.getSelectedItemsForCart ? (window.CareUpsell.getSelectedItemsForCart() || []) : [];
          const mainVariantId = this.variant.id;
          const formScope = btn.closest("product-form") || this.formScope;
          const quantityInput = formScope?.querySelector('quantity-input input[type="number"]');
          const mainQuantity = quantityInput ? parseInt(quantityInput.value) : 1;
          const globoIds = this.getGloboProductionIdArr();
          let allItems = [{ id: mainVariantId, quantity: mainQuantity }];
          if (globoIds.length > 0) {
            allItems = allItems.concat(globoIds.map(id => ({ id, quantity: 1 })));
          }
          allItems = allItems.concat(recommendedProducts);
          allItems = allItems.concat(careItems);
          console.log('allItems', allItems)
          await this.bulkAddToCart(allItems);
          if (window.RecommendedProducts) {
            window.RecommendedProducts.clearSelection();
          }
          if (window.CareUpsell) {
            window.CareUpsell.clearSelection();
          }
          window.location.href = "/checkout";
        } catch (err) {
          console.error("Buy Now failed:", err);
          alert("无法跳转结账，请稍后重试");
        } finally {
          btn.classList.remove("is-loading");
          btn.removeAttribute("aria-disabled");
        }
      });
    };

    initMainBuyBtns() {
      const bindMainActions = () => {
        this.productForm = this.section.querySelector(".js-product-form");
        this.formScope = this.productForm?.closest("product-form") || this.section;

        this.mainBuyNowBtn = this.formScope?.querySelector("#main-buy-now-btn");
        if (this.mainBuyNowBtn && !this.mainBuyNowBtn.__bound) {
          this.mainBuyNowBtn.__bound = true;
          this.bindBuyNow(this.mainBuyNowBtn);
        }

        this.mainNotifyBtn = this.formScope?.querySelector("#main-notify-btn");

        const quantityInput = this.formScope?.querySelector(".product-info__add-to-cart quantity-input");
        if (quantityInput) {
          quantityInput.style.display = !this.variant.available ? "none" : "";
        }

        const addBtnContaner = this.formScope?.querySelector(".product-info__add-button");
        if (addBtnContaner) {
          this.variant.available && addBtnContaner.removeAttribute("disabled");
          !this.variant.available && addBtnContaner.setAttribute("disabled", "");
        }
      };

      bindMainActions();
      const mo1 = new MutationObserver(() => bindMainActions());
      mo1.observe(this.section, { childList: true, subtree: true });
    }

    // for fixed-footer
    initFixedFooter() {
      const variants = this.data.product.variants.map((v) => v.id);
      const noFixedFooter = false; //variants.includes(45973585100987) || variants.includes(45973585133755) || variants.includes(45973585166523) || variants.includes(45973585199291)
      if (noFixedFooter) {
        const vff = document.querySelector("#variant-fixed-footer");
        vff.setAttribute("style", "display: none");
        return;
      }

      // mounted to body for higher picture level
      this.footerEl = document.querySelector("#variant-fixed-footer");
      document.body.appendChild(this.footerEl);

      const titleEl = document.querySelector("#footer-product-title");
      titleEl.textContent = this.variant.public_title;
      window.addEventListener("on:variant:change", () => {
        titleEl.textContent = this.variant.public_title;
      });

      this.footerPriceEl = document.querySelector("#footer-product-price");
      this.updateFixedFooterPrice();

      this.listenElemntTextContent(this.price);

      this.fixedFooterBtn = document.querySelector("#fixed-footer-btn");
      this.mainAtcBtn = document.querySelector("#main_atc");

      this.fixedFooterBtn.addEventListener("click", () => {
        // Get the container div of the add-to-cart buttons
        const addButtonContainer = document.querySelector(
          ".product-info__add-button"
        );

        // 检查是否有选中的推荐产品或 Care 服务
        const recommendedProducts = window.RecommendedProducts?.getSelectedProductsForCart() || [];
        const careItems = window.CareUpsell?.getSelectedItemsForCart ? (window.CareUpsell.getSelectedItemsForCart() || []) : [];

        if (recommendedProducts.length > 0 || careItems.length > 0) {
          // 如果有推荐产品，使用统一加购逻辑
          this.fixedFooterBtn.setAttribute("aria-disabled", "true");
          this.fixedFooterBtn.classList.add("is-loading");

          // 获取主产品信息
          const mainVariantId = this.variant.id;
          const quantityInput = document.querySelector('quantity-input input[type="number"]');
          const mainQuantity = quantityInput ? parseInt(quantityInput.value) : 1;

          // 获取 Globo 附加产品
          const globoIds = this.getGloboProductionIdArr();

          // 组合所有产品：主产品 + Globo 附加产品 + 推荐产品
          let allItems = [{ id: mainVariantId, quantity: mainQuantity }];

          // 添加 Globo 附加产品
          if (globoIds.length > 0) {
            allItems = allItems.concat(globoIds.map(id => ({ id, quantity: 1 })));
          }

          // 添加推荐产品
          allItems = allItems.concat(recommendedProducts);
          // 添加 Care 服务
          allItems = allItems.concat(careItems);

          // 执行统一加购
          this.bulkAddToCart(allItems)
            .then(() => {
              this.fixedFooterBtn.classList.remove("is-loading");
              this.fixedFooterBtn.removeAttribute("aria-disabled");

              // 清空推荐产品选择
              if (window.RecommendedProducts) {
                window.RecommendedProducts.clearSelection();
              }
              // 清空 Care 选择
              if (window.CareUpsell) {
                window.CareUpsell.clearSelection();
              }

              // 使用 setTimeout 确保 clearSelection 完成后再更新价格
              setTimeout(() => {
                this.updateFixedFooterPrice();
              }, 100);
            })
            .catch(() => {
              this.fixedFooterBtn.classList.remove("is-loading");
              this.fixedFooterBtn.removeAttribute("aria-disabled");
            });
        } else {
          // 如果没有推荐产品，使用原有逻辑
          // Determine which button to click based on the number of buttons in the container
          if (addButtonContainer.querySelectorAll("button").length > 1) {
            // If there are more than one button, click on the cloned button
            const clonedAtcButton = addButtonContainer.querySelector(
              ".gpo-clone-atc-button"
            );
            clonedAtcButton && clonedAtcButton.click();
          } else {
            // Otherwise, click on the main add-to-cart button
            this.mainAtcBtn && this.mainAtcBtn.click();
          }

          this.fixedFooterBtn.setAttribute("aria-disabled", "true");
          this.fixedFooterBtn.classList.add("is-loading");

          // Set up a MutationObserver to watch for changes in the cart drawer
          const cartDrawer = document.querySelector("#cart-drawer");
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === "open") {
                // When the cart drawer gets the open attribute, remove loading and disabled states
                this.fixedFooterBtn.classList.remove("is-loading");
                this.fixedFooterBtn.removeAttribute("aria-disabled");
                observer.disconnect(); // Disconnect the observer once the changes are made
              }
            });
          });

          // Start observing the cart drawer for attribute changes
          observer.observe(cartDrawer, { attributes: true });
        }
      });

      // 初始化底部购买按钮
      this.footerBuyNowBtn = document.querySelector("#footer-buy-now-btn");
      if (this.footerBuyNowBtn && !this.footerBuyNowBtn.__bound) { this.footerBuyNowBtn.__bound = true; this.bindBuyNow(this.footerBuyNowBtn); }
      this.footerNotifyBtn = document.querySelector("#footer-notify-btn");
      //this.fixedFooterBtn.addEventListener('click', () => {

      //this.fixedFooterBtn.setAttribute('aria-disabled', 'true')
      //this.fixedFooterBtn.classList.add('is-loading');
      // const idArr = this.getGloboProductionIdArr()
      // this.addToCart([this.variant.id, ...idArr])
      //   .then(async res => {
      //     if(!res) return
      //     await this.openDrawer()

      //   }).finally( () => {
      //     // Re-enable 'Add to Cart' button.
      //     this.fixedFooterBtn.classList.remove('is-loading');
      //     this.fixedFooterBtn.removeAttribute('aria-disabled');
      //   })
      //})
    }
    updateFixedFooterPrice() {
      this.footerPriceEl =
        this.footerPriceEl || document.querySelector("#footer-product-price");
      if (!this.footerPriceEl) return;
      const priceCurrentEl = this.price.querySelector(".price__current");

      // 获取主产品价格文本
      const mainPriceText = priceCurrentEl.textContent;

      // 使用 CurrencyUtils 正确解析价格（支持EU和US格式）
      const mainPriceAmount = window.CurrencyUtils.parsePrice(mainPriceText);

      // 获取推荐产品与 Care 服务总价（现价）
      const recommendedTotal = window.RecommendedProducts?.getRecommendedProductsTotalPrice() || 0;
      const careTotal = window.CareUpsell?.getSelectedTotalPrice ? (window.CareUpsell.getSelectedTotalPrice() || 0) : 0;

      console.log('[VariantPicker] updateFixedFooterPrice - Main:', mainPriceAmount, 'Recommended:', recommendedTotal, 'Care:', careTotal);

      // 计算总价（主商品 + 推荐 + Care）
      const totalAmount = mainPriceAmount + recommendedTotal + careTotal;

      // 价格处理（主商品 compare_at_price - price，保持与主价同格式）
      const priceWasEl = this.price.querySelector(".price__was");
      const compareText = priceWasEl ? priceWasEl.textContent.trim() : "";
      const hasCompare = !!compareText;
      const compareAmount = hasCompare ? window.CurrencyUtils.parsePrice(compareText) : 0;
      const mainUnitAmount = window.CurrencyUtils.parsePrice(mainPriceText);

      // 推荐 + Care 的原价总和（用于展示合计划线价）
      const recommendedOriginal = window.RecommendedProducts?.getRecommendedProductsTotalOriginalPrice
        ? (window.RecommendedProducts.getRecommendedProductsTotalOriginalPrice() || 0)
        : 0;
      const careOriginal = window.CareUpsell?.getSelectedTotalOriginalPrice
        ? (window.CareUpsell.getSelectedTotalOriginalPrice() || 0)
        : 0;

      // 主商品原价 + 各加购原价之和
      const totalOriginalAmount = (hasCompare ? compareAmount : mainUnitAmount) + recommendedOriginal + careOriginal;

      // 折扣 = 原价合计 - 现价合计（仅正值时展示）
      const discountAmount = Math.max(totalOriginalAmount - totalAmount, 0);

      const currentHTML = `<strong class="price__current">${window.CurrencyUtils.formatPrice(totalAmount, mainPriceText)}</strong>`;
      const wasHTML =
        totalOriginalAmount > totalAmount
          ? `<s class="price__was">${window.CurrencyUtils.formatPrice(totalOriginalAmount, compareText || mainPriceText)}</s>`
          : "";
      const showDiscount = this.footerEl?.dataset?.showDiscount !== "false";
      const discountHTML =
        showDiscount && discountAmount > 0
          ? `<span class="price__discount-amount">${window.CurrencyUtils.formatPrice(discountAmount, mainPriceText)} Off</span>`
          : "";
      this.footerPriceEl.innerHTML = `<div class="price__container">${currentHTML}${wasHTML}</div>${discountHTML}`;

      // 更新paypal价格（始终使用标准数字格式）
      const ppContainer = document.querySelector(".paypal-container");
      if (ppContainer) {
        ppContainer.setAttribute("data-pp-amount", totalAmount.toFixed(2));
      }

      // 更新affirm价格（使用分为单位）
      const affirmElement = document.querySelector("#sho-aff-content");
      if (affirmElement) {
        affirmElement.setAttribute(
          "data-amount",
          Math.round(totalAmount * 100)
        );
        if (window.affirm?.ui && typeof window.affirm.ui.ready === "function") {
          window.affirm.ui.ready(() => {
            if (typeof window.affirm.ui.refresh === "function") {
              window.affirm.ui.refresh();
            }
          });
        }
      }

      // 后续更新
    }
    /**
     * get curr page globproduction List's id
     * @returns variant id array. e.g. ['44701686825147', '40891374928059', '42371791028411']
     */
    getGloboProductionIdArr() {
      if (!document.querySelector(".gpo-hidden-inputs")) {
        //console.warn('$$ globo not ready, add to cart without globo product')
        return [];
      }
      const inputList = document.querySelector(".gpo-hidden-inputs").children;
      let res = [];
      for (let i = 0; i < inputList.length; i++) {
        const curr = inputList[i];
        if (!curr.getAttribute("gpo-data-variant-id")) continue;
        let idArr = [];
        idArr = curr.getAttribute("gpo-data-variant-id").split(",");
        res = res.concat(idArr);
      }
      // console.log('$1',res)
      return res;
    }
    /**
     * https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
     * update cart
     * @param idArr variant id array. e.g. ['44701686825147', '40891374928059', '42371791028411']
     */
    async addToCart(idArr) {
      let error = "";
      try {
        const items = idArr.map((v) => ({ id: v, quantity: 1 }));
        const fetchRequestOpts = {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ items }),
        };
        const response = await fetch(
          theme.routes.cartAdd + ".js",
          fetchRequestOpts
        );

        const data = await response.json();

        if (data.status) {
          error = data.description;
        }

        if (!response.ok) throw new Error(response.status);

        return true;
      } catch (err) {
        console.error(err); // eslint-disable-line
        window.alert(error);
        // this.dispatchEvent(new CustomEvent('on:cart:error', {
        //   bubbles: true,
        //   detail: {
        //     error: error || 'get error, please reload the page and try later'
        //   }
        // }));
        return false;
      }
    }
    openDrawer() {
      return new Promise((resolve, reject) => {
        const _open = () => {
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
          resolve();
        };
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true, // 是否冒泡
            detail: { cb: _open },
          })
        );
      });
    }
    listenElemntTextContent() {
      this.price =
        this.price ||
        this.section.querySelector(".product-info__price > .price");
      if (!this.price) {
        setTimeout(() => {
          this.listenElemntTextContent();
        }, 5000);
      }

      // 观察器的配置（需要观察什么变动）
      const config = { childList: true, characterData: true, subtree: true };

      const that = this;
      // 当观察到变动时执行的回调函数
      const callback = function (mutationsList, observer) {
        that.updateFixedFooterPrice();
      };

      // 创建一个观察器实例并传入回调函数
      const observer = new MutationObserver(callback);

      // 以上述配置开始观察目标节点
      observer.observe(this.price, config);
    }

    // for App: Global options 44701686759611
    globoHandleClass() {
      const container = document.querySelector(".gpo-app");
      if (!container) {
        setTimeout(() => this.globoHandleClass(), 500);
        return;
      }
      const elAry = container.querySelectorAll(".gpo-element");
      elAry.forEach((el) => {
        const classStr = el.getAttribute("class");
        const messge = el.querySelector(".gpo-helptext");

        if (messge && classStr.indexOf("snmk-globo") > 0) {
          const addedClassStr = messge.textContent;
          el.setAttribute("class", `${classStr} ${addedClassStr}`);
        }
      });
      document.dispatchEvent(new CustomEvent("snmk:globo-class-handle"));
    }
    handleVariantTitle(title) {
      title = title
        .toLowerCase()
        .replaceAll(/[\/\$\%\@\#\*\>\~\(\)\[\]\{\}\'\"\,]/g, "");
      title = title.toLowerCase().replaceAll(/\./g, "-");
      title = title.toLowerCase().replaceAll(/\&/g, "and");
      title = title.toLowerCase().replaceAll(/\+/g, "and");

      if (/^[0-9]/.test(title)) {
        return `.snmk-${title.toLowerCase().replaceAll(/ /g, "-")}`;
      } else {
        return `.${title.toLowerCase().replaceAll(" ", "-")}`;
      }
    }
    initGlobalOptions() {
      this.globoHandleClass();
      try {
        this.optsArr = [];
        const set = new Set();
        this.data.product.variants.forEach((vObj) => {
          vObj.options.forEach((v) => {
            if (set.has(v)) return;
            set.add(v);
            const els = document.querySelectorAll(this.handleVariantTitle(v));
            this.optsArr.push({ els, title: v });
          });
        });
        const selectedOptions = this.getSelectedOptions();
        let css = ``;
        let displayCss = "";
        this.optsArr.forEach((option) => {
          if (selectedOptions.indexOf(option.title) >= 0) {
            displayCss += `${this.handleVariantTitle(
              option.title
            )} { display: block } `;
          } else {
            css += `${this.handleVariantTitle(
              option.title
            )} { display: none } `;
          }
        });
        css = displayCss + css;
        const style = document.createElement("style");
        style.innerHTML = css;
        document.head.appendChild(style);
      } catch (err) {
        console.error("initGlobalOptions get error", err);
      }
      // this.GloboProductOptionsApp(selectedOptions)
    }
    GloboProductOptionsApp(selectedOptions) {
      // no inventory will hidden all Global options
      // if(this.data && this.variant && this.data.inventory[this.variant.id] <= 0) {
      //   const gpo = document.querySelector('.gpo-container')
      //   gpo.style.display = 'none'
      //   return
      // }
      const setDisplayToEls = (els, display) =>
        els.forEach((el) => el && (el.style.display = display));

      const result = [];
      this.optsArr.forEach((option) => {
        option.els.length <= 0 &&
          (option.els = document.querySelectorAll(
            this.handleVariantTitle(option.title)
          ));
        if (selectedOptions.indexOf(option.title) < 0) {
          result.push(...option.els);
        } else {
          option.els && setDisplayToEls(option.els, "block");
        }
        // if (selectedOptions.indexOf(option.title) >= 0) {
        //   option.els && setDisplayToEls(option.els, 'block')
        //   selectedOptions = selectedOptions.splice(selectedOptions.indexOf(option.title), 1)
        // } else {
        //   option.els && setDisplayToEls(option.els, 'none')
        // }
      });
      setDisplayToEls(result, "none");
    }
    updateFixedFooterBtnStatus(disabled, text) {
      this.fixedFooterBtn = document.querySelector("#fixed-footer-btn");
      if (!this.fixedFooterBtn) return;
      this.fixedFooterBtn.textContent = text;
      disabled
        ? this.fixedFooterBtn.setAttribute("disabled", disabled)
        : this.fixedFooterBtn.removeAttribute("disabled");
    }

    // custom variant interaction
    getProductVariantData() {
      const dataEl = document.querySelector("#variant-metafield");
      try {
        return JSON.parse(dataEl.textContent);
      } catch (err) {
        console.error("getProductVariantData  get error: ", err);
        return {};
      }
    }
    arraysAreEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }

      const sortedArr1 = arr1.slice().sort();
      const sortedArr2 = arr2.slice().sort();

      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          return false;
        }
      }

      return true;
    }
    getNotAppliedOptionsByVariantId(variantId) {
      return this.variantIdMap[variantId].filter((v) => {
        const keys = Object.keys(this.variantMetafield);
        const secondKeys = Object.keys(this.variantMetafield[keys[0]]);
        const isFirstKeys = this.data["v2-variant"].includes(
          keys[0].toLowerCase().trim()
        );
        const appliedOptions = isFirstKeys ? keys : secondKeys;
        return !appliedOptions.includes(v);
        // const appliedOptions = Object.keys(this.variantMetafield)
        // console.log('sssss', this.variantMetafield, Object.keys(this.variantMetafield), v)
        // return !appliedOptions.includes(v)
      });
    }
    getVariantIdByAllOptions(options) {
      const keys = Object.keys(this.variantIdMap);
      for (let i = 0; i < keys.length; i++) {
        const variantId = keys[i];
        if (this.arraysAreEqual(this.variantIdMap[variantId], options)) {
          return variantId;
        }
      }
    }
    getImageElByVariantId(variantId, isInit) {
      const container = document.querySelector("#variant-image-container");
      const imgEl = container.querySelector(`.variant-image-${variantId}`);
      if (!imgEl) return "";
      if (isInit) {
        return imgEl.cloneNode(true);
      } else {
        if (!imgEl.querySelector("img")) {
          return "";
        }
        let src = imgEl.querySelector("img").src;
        // const variant = this.data.product.variants.find(v=>v.id == variantId)
        return src || "";
      }
    }
    mapVariantIdToOptions(variant) {
      this.variantIdMap = {};
      variant.forEach((v) => {
        this.variantIdMap[v.id] = v.options;
      });
    }
    updateProductVariantAdditionData(currVariant, isInit) {
      if (!currVariant) return;
      this.price =
        this.price ||
        this.section.querySelector(".product-info__price > .price");
      
      const keys = Object.keys(this.variantMetafield || {});
      if (keys.length === 0) return;

      const firstKeyData = this.variantMetafield[keys[0]];
      if (!firstKeyData) return;
      
      const secondKeys = Object.keys(firstKeyData);
      const isFirstKeys = this.data["v2-variant"].includes(
        keys[0].toLowerCase().trim()
      );
      let targetKeys = isFirstKeys ? keys : secondKeys;
      // console.log('$$secondKeys', secondKeys, targetKeys, this.data["v2-variant"])
      targetKeys.forEach((key) => {
        const variantEl = document.querySelector(
          `#vp-${this.handleVariantTitle(key).slice(1)}`
        );
        if (!variantEl || !variantEl.parentElement) {
          console.warn(
            "no parentElement variant",
            this.variant,
            `#vp-${this.handleVariantTitle(key).slice(1)}`
          );
          return;
        }
        let wrapper = variantEl.parentElement.querySelector(
          ".variant-addition-text"
        );
        const priceCurrentEl = this.price.querySelector(".price__current");
        const priceWasEl = this.price.querySelector(".price__was");

        // 获取非改样式的variant options
        const notApplidOptions = this.getNotAppliedOptionsByVariantId(
          this.variant.id
        );

        // 用 非改样式的variant options加上当前key 来获取 其对应的id
        const currOptions = notApplidOptions.slice();
        currOptions.push(key);
        const currentOptionVariantId =
          this.getVariantIdByAllOptions(currOptions);

        //console.log('$$$0', currentOptionVariantId, notApplidOptions,currOptions, this.variant.id, this.variantIdMap)
        // 用variant id 获取 对应的图片元素
        const imgELorSrc = this.getImageElByVariantId(
          currentOptionVariantId,
          isInit
        );

        const hasSecondKeys = !secondKeys.includes("isSingleVariant");
        let variantAdditionData;
        if (!hasSecondKeys) {
          // 单层结构：key 本身即 variant option value
          variantAdditionData = this.variantMetafield[key];
        } else {
          // 两层嵌套结构：key 是与 metafield 对应的 option value，
          // companion 是当前 variant 中另一个属于 metafield 维度的 option value。
          // 不能把所有未应用的 option 用 "," 拼成 key，否则多出的 "Ship to"
          // 之类 option（如 shop 站 3 个 option）会让 key 拼错、查不到数据。
          const companions =
            currVariant && Array.isArray(currVariant.options)
              ? currVariant.options.filter((o) => o !== key)
              : notApplidOptions;
          variantAdditionData = companions
            .map((o) =>
              this.variantMetafield[key]?.[o] !== undefined
                ? this.variantMetafield[key][o]
                : this.variantMetafield[o]?.[key]
            )
            .find((data) => data !== undefined);
        }
        if (!variantAdditionData) return;
        const noInventory = this.data.inventory[currentOptionVariantId] == 0;
        if (noInventory) {
          variantEl.parentElement.setAttribute("noinventory", true);
          variantEl.parentElement.setAttribute("title", "sold out");
        } else {
          variantEl.parentElement.removeAttribute("noinventory");
          variantEl.parentElement.removeAttribute("title");
        }

        const enableV2 =
          this.dataset.enableV2 === "true" ||
          this.dataset.enableV2 === "1" ||
          this.dataset.enableV2 === "True";
        const hasChildren =
          variantAdditionData &&
          Array.isArray(variantAdditionData.items) &&
          variantAdditionData.items.length > 0;

        if (enableV2 && hasChildren) {
          variantEl.parentElement.classList.add("variant-has-items");
          const headerWrapper =
            variantEl.parentElement.querySelector(".variant-v2-header");
          const detailsWrapper =
            variantEl.parentElement.querySelector(".variant-combo-details");
          const priceText =
            this.data.formatted[currentOptionVariantId]?.price || "";
          const compareText =
            this.data.formatted[currentOptionVariantId]?.compareAtPrice || "";
            
          const buildDetails = () => {
            let details = variantEl.parentElement.querySelector(
              ".variant-combo-details"
            );
            if (!details) {
              details = document.createElement("div");
              details.classList.add("variant-combo-details");
              const titleEl = document.createElement("div");
              titleEl.classList.add("variant-combo-details__title");
              titleEl.textContent = "Packing List:";
              const grid = document.createElement("div");
              grid.classList.add("variant-combo-grid");
              details.appendChild(titleEl);
              details.appendChild(grid);
              variantEl.parentElement.appendChild(details);
            }
            const grid = details.querySelector(".variant-combo-grid");
            grid.innerHTML = "";
            variantAdditionData.items.forEach((item) => {
              const it = document.createElement("div");
              it.classList.add("variant-combo-item");
              const left = document.createElement("div");
              left.classList.add("variant-combo-item__left");
              if (item.image) {
                const imgWrap = document.createElement("div");
                imgWrap.classList.add("variant-combo-item__img");
                const img = new Image();
                img.src = item.image;
                imgWrap.appendChild(img);
                left.appendChild(imgWrap);
              }
              const name = document.createElement("div");
              name.classList.add("variant-combo-item__name");
              name.textContent = item.title || "";
              name.title = item.title || "";
              left.appendChild(name);
              const qty = document.createElement("div");
              qty.classList.add("variant-combo-item__qty");
              qty.textContent = item.qty ? `× ${item.qty}` : "";
              it.appendChild(left);
              it.appendChild(qty);
              grid.appendChild(it);
            });
            return details;
          };

          const buildHeader = () => {
            const header = document.createElement("div");
            header.classList.add("variant-v2-header");
            const top = document.createElement("div");
            top.classList.add("variant-v2-header__top");
            const discount = document.createElement("div");
            discount.classList.add("variant-discount");
            // 计算货币折扣金额（compareAt - price），有 items 时显示金额 Off
            let label = "";
            try {
              const priceAmount = window.CurrencyUtils
                ? window.CurrencyUtils.parsePrice(priceText)
                : 0;
              const compareAmount = compareText
                ? (window.CurrencyUtils
                    ? window.CurrencyUtils.parsePrice(compareText)
                    : 0)
                : 0;
              const diff = 
                compareAmount > priceAmount ? compareAmount - priceAmount : 0;
              if (diff > 0) {
                label = window.CurrencyUtils
                  ? `${window.CurrencyUtils.formatPrice(diff, priceText)} Off`
                  : `${diff} Off`;
              }
            } catch (e) {
              label = "";
            }
            discount.textContent = label;
            if (!label) discount.style.display = "none";
            if (this.dataset.showHasChildrenDiscount !== "false") {
              top.appendChild(discount);
            }
            const row = document.createElement("div");
            row.classList.add("variant-v2-row");
            const titleCol = document.createElement("div");
            titleCol.classList.add("variant-v2-title");
            const title = document.createElement("div");
            title.classList.add("variant-title");
            title.textContent = variantAdditionData.title || "";
            title.title = variantAdditionData.title || "";
            titleCol.appendChild(title);
            const priceCol = document.createElement("div");
            priceCol.classList.add("variant-v2-price");
            const priceCurrent = document.createElement("div");
            priceCurrent.classList.add("variant-price-current");
            priceCurrent.textContent = priceText;
            const priceCompare = document.createElement("div");
            priceCompare.classList.add("variant-price-compare");
            priceCompare.textContent = compareText || "";
            priceCol.appendChild(priceCurrent);
            priceCol.appendChild(priceCompare);
            row.appendChild(titleCol);
            row.appendChild(priceCol);
            header.appendChild(top);
            header.appendChild(row);
            return header;
          };

          if (!headerWrapper || !detailsWrapper) {
            variantEl.parentElement.addEventListener("click", () => {
              variantEl.click();
              targetKeys.forEach((key0) => {
                const el = document.querySelector(
                  `#vp-${this.handleVariantTitle(key0).slice(1)}`
                );
                if (!el) return;
                el.parentElement.removeAttribute("isSelected");
                const d = el.parentElement.querySelector(
                  ".variant-combo-details"
                );
                if (d) d.style.display = "none";
              });
              variantEl.parentElement.setAttribute("isSelected", true);
              const d2 = variantEl.parentElement.querySelector(
                ".variant-combo-details"
              );
              if (d2) d2.style.display = "block";
            });
            const header = buildHeader();
            const details = buildDetails();
            if (!variantEl.parentElement.querySelector(".variant-v2-header")) {
              variantEl.parentElement.insertBefore(
                header,
                variantEl.parentElement.firstChild
              );
            }
            if (!variantEl.parentElement.querySelector(".variant-combo-details")) {
              variantEl.parentElement.appendChild(details);
            }
            const show =
              variantEl.parentElement.hasAttribute("isSelected") || false;
            const detailsEl = variantEl.parentElement.querySelector(
              ".variant-combo-details"
            );
            if (detailsEl)
              detailsEl.style.display = show ? "block" : "none";
          } else {
            const titleEl =
              variantEl.parentElement.querySelector(".variant-title");
            const priceCurrEl =
              variantEl.parentElement.querySelector(".variant-price-current");
            const priceCompEl =
              variantEl.parentElement.querySelector(".variant-price-compare");
            const discountEl =
              variantEl.parentElement.querySelector(".variant-discount");
            if (titleEl) {
              titleEl.textContent = variantAdditionData.title || "";
              titleEl.title = variantAdditionData.title || "";
            }
            if (priceCurrEl) priceCurrEl.textContent = priceText;
            if (priceCompEl) priceCompEl.textContent = compareText || "";
            if (discountEl) {
              let label = "";
              try {
                const priceAmount = window.CurrencyUtils
                  ? window.CurrencyUtils.parsePrice(priceText)
                  : 0;
                const compareAmount = compareText
                  ? (window.CurrencyUtils
                      ? window.CurrencyUtils.parsePrice(compareText)
                      : 0)
                  : 0;
                const diff =
                  compareAmount > priceAmount ? compareAmount - priceAmount : 0;
                if (diff > 0) {
                  label = window.CurrencyUtils
                    ? `${window.CurrencyUtils.formatPrice(diff, priceText)} Off`
                    : `${diff} Off`;
                }
              } catch (e) {
                label = "";
              }
              discountEl.textContent = label;
              discountEl.style.display = label ? "block" : "none";
            }
            const details = buildDetails();
            const show =
              variantEl.parentElement.hasAttribute("isSelected") || false;
            details.style.display = show ? "block" : "none";
          }
          return;
        }

        // 回退到原有 v2 逻辑：清理 has-items 分支插入的结构和样式
        variantEl.parentElement.classList.remove("variant-has-items");
        const headerToRemove =
          variantEl.parentElement.querySelector(".variant-v2-header");
        const detailsToRemove =
          variantEl.parentElement.querySelector(".variant-combo-details");
        headerToRemove && headerToRemove.remove();
        detailsToRemove && detailsToRemove.remove();

        if (isInit || !wrapper) {
          const that = this;
          variantEl.parentElement.addEventListener("click", () => {
            variantEl.click();
            targetKeys.forEach((key) => {
              const el = document.querySelector(
                `#vp-${this.handleVariantTitle(key).slice(1)}`
              );
              if (!el) return;
              el.parentElement.removeAttribute("isSelected");
            });
            variantEl.parentElement.setAttribute("isSelected", true);
          });

          const textStyleEl = document.createElement("div");
          const text = document.createElement("div");
          const title = document.createElement("div");
          const price = document.createElement("div");
          const textContainer = document.createElement("div");
          const inventory = document.createElement("div");
          const container = document.createElement("div");
          const discount = document.createElement("div");
          const desc = document.createElement("div");

          text.classList.add("variant-addition-text");
          textStyleEl.classList.add("variant-text-style-box");
          price.classList.add("variant-price");
          title.classList.add("variant-title");
          text.innerHTML = ``;
          title.innerHTML = `${variantAdditionData.title || ""}`;
          this.price &&
            (price.innerHTML = `${
              this.data.formatted[currentOptionVariantId]?.price
            } <s>${
              this.data.formatted[currentOptionVariantId]?.compareAtPrice || ""
            }</s>`);
          text.appendChild(textStyleEl);
          textStyleEl.appendChild(title);
          textStyleEl.appendChild(price);

          textContainer.classList.add("variant-text-container");
          let img;
          if (typeof imgELorSrc === "string") {
            img = document.createElement("div");
            img.classList.add(`variant-image-${currVariant.id}`);
            img.classList.add(`img-wrapper`);
            const imgEl = new Image();
            imgEl.src = imgELorSrc;
            img.appendChild(imgEl);
          } else {
            img = imgELorSrc;
          }
          textContainer.appendChild(img);
          textContainer.appendChild(text);

          inventory.classList.add("variant-inventory-wrapper");
          const inventoryText = noInventory
            ? `sold out`
            : `% available for sale`;
          inventory.innerHTML = `<progress id="variant-inventory-progress" max="${variantAdditionData.InventoryTotalQuantity}" value="${this.data.inventory[currentOptionVariantId]}">70%</progress>
          <div class="variant-inventory">${this.data.inventory[currentOptionVariantId]} left of ${variantAdditionData.InventoryTotalQuantity}</div>`;
          // <div class="variant-inventory">${this.data.inventory[currentOptionVariantId]} / ${variantAdditionData.InventoryTotalQuantity}</div>`
          // <span>Limited Qts</span><br>
          // inventory.innerHTML = `<progress id="variant-inventory-progress" max="${variantAdditionData.InventoryTotalQuantity}" value="${this.data.inventory[currentOptionVariantId]}">70%</progress>`
          // <div class="variant-inventory">${Math.ceil(this.data.inventory[currentOptionVariantId] / variantAdditionData.InventoryTotalQuantity * 100) || ''}${inventoryText}</div>

          container.classList.add("variant-content-container");
          container.appendChild(textContainer);
          container.appendChild(inventory);

          discount.classList.add("variant-discount");
          discount.innerHTML = `${variantAdditionData.off}`;
          if (!variantAdditionData.off) {
            discount.style.display = "none";
          }

          desc.classList.add("variant-desc");
          desc.innerHTML = `${variantAdditionData.desc}`;
          if (!variantAdditionData.desc) {
            desc.style.display = "none";
          }

          if (
            !variantEl.parentElement.querySelector(".variant-content-container")
          ) {
            variantEl.parentElement.insertBefore(
              container,
              variantEl.parentElement.children[0]
            );
          }
          // if(!variantEl.parentElement.querySelector('.variant-discount')) {
          variantEl.parentElement.append(discount);
          // }
          if (!variantEl.parentElement.querySelector(".variant-desc")) {
            variantEl.parentElement.append(desc);
          }
          // variantEl.parentElement.insertBefore(discount, variantEl.parentElement.children[0])
        } else {
          const title = variantEl.parentElement.querySelector(`.variant-title`);
          const price = variantEl.parentElement.querySelector(`.variant-price`);
          const inventory =
            variantEl.parentElement.querySelector(`.variant-inventory`);
          const inventoryProgress = variantEl.parentElement.querySelector(
            `#variant-inventory-progress`
          );
          let discount =
            variantEl.parentElement.querySelector(`.variant-discount`);
          let desc = variantEl.parentElement.querySelector(`.variant-desc`);

          title.innerHTML = `${variantAdditionData.title}`;
          this.price &&
            (price.innerHTML = `${
              this.data.formatted[currentOptionVariantId].price
            } <s>${
              this.data.formatted[currentOptionVariantId].compareAtPrice || ""
            }</s>`);
          inventory.innerHTML = `${this.data.inventory[currentOptionVariantId]} left of ${variantAdditionData.InventoryTotalQuantity}`;

          inventoryProgress.max = variantAdditionData.InventoryTotalQuantity;
          inventoryProgress.value = this.data.inventory[currentOptionVariantId];
          desc.innerHTML = `${variantAdditionData.desc || ""}`;
          discount.innerHTML = `${variantAdditionData.off || ""}`;

          if (!variantAdditionData.desc) {
            desc && (desc.style.display = "none");
          }

          if (!variantAdditionData.off) {
            discount && (discount.style.display = "none");
          } else {
            discount && (discount.style.display = "block");
          }

          const img = variantEl.parentElement.querySelector(`.img-wrapper img`);
          img && (img.src = imgELorSrc);
        }
      });
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateBuyRelateBtnsStatus(!this.variant.available);
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      try {
        logSelectModel(this.data.product.title, this.variant.title);
      } catch (err) {
        console.error("logSelectModel get error:", err);
      }

      try {
        this.GloboProductOptionsApp(selectedOptions);
      } catch (err) {
        //console.error('$$ initGlobalOptions get error', err)
      }
      try {
        this.updateProductVariantAdditionData(this.variant);
      } catch (err) {
        //console.error('$$ updateProductVariantAdditionData get error', err)
      }

      this.dispatchEvent(
        new CustomEvent("on:variant:change", {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product,
          },
        })
      );
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector(".js-product-form");
      if (!this.productForm) return;

      this.addBtn =
        this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant
        ? theme.strings.noStock
        : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;

      const addBtnContaner = this.productForm.querySelector(".product-info__add-button");
      variantAvailable && addBtnContaner.classList.remove("disabled");
      !variantAvailable && addBtnContaner.classList.add("disabled");

      this.updateFixedFooterBtnStatus(
        !variantAvailable,
        this.addBtn.textContent
      );
    }

    /**
     * 根据变体可用性更新购买相关按钮的状态（Buy Now，Notify Me）。
     * @param {boolean} isDisabled - 当前变体是否不可用.
     */
    updateBuyRelateBtnsStatus(isDisabled) {
      const quantityInput = document.querySelector(".product-info__block .product-info__add-to-cart quantity-input");
      if (quantityInput) {
        quantityInput.style.display = isDisabled ? "none" : "";
      }
      if (this.mainBuyNowBtn) {
        this.mainBuyNowBtn.style.display = isDisabled ? "none" : "";
      }
      if (this.mainNotifyBtn) {
        this.mainNotifyBtn.style.display = isDisabled ? "" : "none";
      }
      if (this.footerBuyNowBtn) {
        this.footerBuyNowBtn.style.display = isDisabled ? "none" : "";
      }
      if (this.footerNotifyBtn) {
        this.footerNotifyBtn.style.display = isDisabled ? "" : "none";
      }
      
      const addBtnContaner = this.productForm.querySelector(".product-info__add-button");
      if (!this.productForm) return;
      !isDisabled && addBtnContaner.removeAttribute("disabled");
      isDisabled && addBtnContaner.setAttribute("disabled", "");
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === "false") return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      const updateOptionAvailability = (
        optionEl,
        available,
        soldout,
        isSetHidden
      ) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle("is-unavailable", !available);

        if (optionEl.classList.contains("custom-select__option")) {
          const em = el.querySelector("em");

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute("title");
        }
        if (isSetHidden) {
          if (!soldout && !available) {
            el.nextElementSibling.style.display = "none";
            const parent = el.closest(".product-variant-wrapper");
            if (parent.hasAttribute("isSelected")) {
              parent.style.display = "block";
              return;
            }
            if (parent) parent.style.display = "none";
          } else {
            el.nextElementSibling.style.display = "flex";
            const parent = el.closest(".product-variant-wrapper");
            if (parent) parent.style.display = "block";
          }
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll(".js-option").forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (
              option === currVariant.options[optionIndex] &&
              optionIndex !== selectorIndex
            ) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll(".js-option");
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === "dropdown") {
                // The visible option label may be translated by a page
                // translation app; match on the raw data-value attribute
                // which always keeps the original option value.
                return opt.dataset.value === variant.options[selectorIndex];
              }
              // Same for the listed picker: match on the input's raw value
              // attribute instead of the (possibly translated) label text.
              return opt.value === variant.options[selectorIndex];
            });

            if (optionEl) {
              updateOptionAvailability(
                optionEl,
                variant.available,
                !variant.available,
                selectorIndex !== 0
              );
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder =
        this.backorder || this.section.querySelector(".backorder");
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === "none") {
          const backorderProdEl = this.backorder.querySelector(
            ".backorder__product"
          );
          const prodTitleEl = this.section.querySelector(".product-title");
          const variantTitle = this.variant.title.includes("Default")
            ? ""
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest(".option-selector");
      if (selector.dataset.selectorType === "dropdown") return;

      const colorText = selector.querySelector(".js-color-text");
      if (!colorText) return;

      colorText.textContent =
        evt.target.nextElementSibling.querySelector(".js-value").textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches("quick-add-drawer")) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery =
          this.mediaGallery || this.section.querySelector("media-gallery");
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability ||
        this.section.querySelector("pickup-availability");
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute("available");
        this.pickUpAvailability.innerHTML = "";
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price =
        this.price ||
        this.section.querySelector(".product-info__price > .price");
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector(".price__current");
        const priceWasEl = this.price.querySelector(".price__was");
        const unitPriceEl = this.price.querySelector(".unit-price");

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.textContent =
            this.data.formatted[this.variant.id].compareAtPrice || "";

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector(".unit-price__price");
          const unitEl = this.price.querySelector(".unit-price__unit");
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.textContent = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          "price--on-sale",
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle("price--sold-out", !this.variant.available);

        // Update discount amount text
        let discountEl = this.price.querySelector(".price__discount-amount");
        const onSale = this.variant.compare_at_price > this.variant.price;
        if (discountEl) {
          if (onSale) {
            const currentText = this.data.formatted[this.variant.id].price;
            const compareText =
              this.data.formatted[this.variant.id].compareAtPrice || "";
            const currentAmount =
              window.CurrencyUtils.parsePrice(currentText) || 0;
            const compareAmount =
              window.CurrencyUtils.parsePrice(compareText) || 0;
            const discountAmount = Math.max(compareAmount - currentAmount, 0);
            discountEl.textContent = `${window.CurrencyUtils.formatPrice(
              discountAmount,
              currentText
            )} Off`;
            discountEl.style.display =
              discountAmount > 0 ? "inline-block" : "none";
          } else {
            discountEl.style.display = "none";
          }
        }
      }

      this.price.querySelector(".price__default").hidden = !this.variant;
      this.price.querySelector(".price__no-variant").hidden = this.variant;

      // for fixed footer
      this.updateFixedFooterPrice();
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector(".product-sku__value");
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : "";
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== "change" || this.dataset.updateUrl === "false")
        return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.variant.id}`
      );
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms ||
        this.section.querySelectorAll(".js-product-form, .js-instalments-form");

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
      const footerForm = document.querySelector(
        "#variant-fixed-footer .js-product-form"
      );
      if (footerForm) {
        const input = footerForm.querySelector('input[name="id"]');
        if (input) {
          input.value = this.variant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === "dropdown") {
          // The selected option's raw value lives in its data-value
          // attribute; the button's visible text may have been translated
          // by a page translation app and no longer matches the
          // untranslated variant option values.
          const selectedOption = selector.querySelector(
            '.custom-select__option[aria-selected="true"]'
          );
          selectedOptions.push(
            selectedOption
              ? selectedOption.dataset.value
              : selector.querySelector(".custom-select__btn").textContent.trim()
          );
        } else {
          selectedOptions.push(selector.querySelector("input:checked").value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      // const dataEl = this.querySelector('[type="application/json"]');
      // return JSON.parse(dataEl.textContent);
      const dataEl = this.querySelector(
        '#product-data[type="application/json"]'
      );
      const data = JSON.parse(dataEl.textContent);
      return data;
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
